<div class="return-container" id="return-container">
  <ng-container *ngIf="!showForm && orderItem">
    <div class="order-main-title">Returns</div>
    <form id="returnForm" [formGroup]="returnForm">
      <div class="order-title">Order Item #{{ orderItem.id }}</div>
      <div class="sub-title">You placed this order on {{ orderItem.createdAt | date: 'medium' }}</div>
      <div class="box-left">
        <img [src]="orderItem.imageUrl" class="product-image" />
        <div class="product-name">{{ orderItem.productName }}</div>
        <div class="price">{{ orderItem.price | currency: orderItem.currencyCode }}</div>
      </div>
      <div class="box-right">
        <div class="box-input">
          <div><label>Return reason</label></div>
          <input type="text" formControlName="reason" />
        </div>
        <div *ngIf="!isUserLoggedIn" class="box-input">
          <re-captcha
            formControlName="recaptchaReactive"
            siteKey="{{ recaptcha_site_key }}"
            (resolved)="resolved($event)"
          ></re-captcha>
        </div>
        <button
          class="cta-btn btn-return"
          (click)="returnOrder()"
          [disabled]="returnForm.status === 'INVALID' || !isUserLoggedIn"
        >
          Return
        </button>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="showForm">
    <div class="order-main-title search">Returns</div>
    <form id="searchForm" [formGroup]="searchForm">
      <div class="box-input">
        <div><label class="lbl-search">Email</label></div>
        <input type="text" formControlName="email" />
      </div>
      <div class="box-input">
        <div><label class="lbl-search">Order item number</label></div>
        <input type="text" formControlName="orderItemId" />
      </div>
      <div class="cta-btn btn-return" (click)="showProduct()">Search</div>
      <div *ngIf="notFound" class="not-found">Order Item not found</div>
    </form>
  </ng-container>
</div>
